module.exports = __webpack_public_path__ + "front/img/bj.057989da.png";